import React, { memo, forwardRef } from "react";
const SvgCapitalM = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M23.64 21.86c0 .307-.047.553-.14.74a1.347 1.347 0 01-.34.42 1.06 1.06 0 01-.42.18 1.22 1.22 0 01-.34.06c-.107 0-.233-.02-.38-.06a1.064 1.064 0 01-.4-.18 1.344 1.344 0 01-.34-.42c-.094-.187-.14-.433-.14-.74v-8.1h-.04l-3.68 8.32c-.227.507-.474.833-.74.98-.267.133-.514.2-.74.2-.24 0-.493-.067-.76-.2-.267-.147-.514-.473-.74-.98l-3.62-8.28h-.06v8.12c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.908.908 0 01-.4.18c-.133.04-.247.06-.34.06-.107 0-.227-.02-.36-.06a1.065 1.065 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7V10.48c0-.373.053-.673.16-.9.12-.227.26-.4.42-.52.173-.133.347-.22.52-.26.187-.04.353-.06.5-.06.12 0 .253.02.4.06.147.027.293.093.44.2.16.093.313.24.46.44.16.187.313.447.46.78l4.28 9.9h.04l4.3-9.9c.146-.333.293-.593.44-.78.16-.2.313-.347.46-.44.16-.107.307-.173.44-.2.146-.04.28-.06.4-.06.133 0 .287.02.46.06.187.04.36.127.52.26.16.12.293.293.4.52.12.227.18.527.18.9v11.38z"
      />
    </svg>
  );
});
SvgCapitalM.displayName = "SvgCapitalM";
const MemoForwardRef = memo(SvgCapitalM);
export default MemoForwardRef;
